<template>
<template v-if="isExpress">
	<component
		:is="iconComponent"
		v-if="iconComponent"
		filled
		:style="expressStyle"
		:class="props.class"
	/>
</template>
<i v-else data-component="OIcon.vue" class="i" :style="standardStyle" :class="props.class" :title="title" v-html="iconString"/>
</template>

<script setup lang="ts">
import { computed, ref, watch } from 'vue';
import { getIcon } from './Icon/configs/iconConfig';

const props = withDefaults(
	defineProps<{
      // Nazwa ikony (zazwyczaj nazwa plku .svg)
      name?: string;
      // Nazwa zestawu ikon (zazwyczaj nazwa folderu)
      set?: string;
      // Wielkość ikony (w rem)
      size?: string | number;
      // Nadpisanie wysokości (w rem)
      height?: string | number;
      // Styl wyświetlania
      display?: string;
      // Tytuł elementu
      title?: string;
      // Klasa
      class?: string | string[];
    }>(),
	{
		name: 'placeholder',
		set: 'base',
		display: 'inline-block',
		class: '',
	},
);

const iconString = ref('');

const isExpress = computed(() => props.set === 'express');
const iconComponent = computed(() => `svgo-${props.name}`);

watch(
	() => props.name,
	async (val) => {
		if (!isExpress.value) {
			iconString.value = await getIcon(props.set, val);
		}
	},
	{ immediate: true },
);

// Style dla komponentów Express
const expressStyle = computed(() => (props.size ? { width: `${props.size}rem`, height: `${props.size}rem` } : {}));

// Style dla standardowych ikon
const standardStyle = computed(() => ({
	display: props.display,
	width: `${props.size || 1.25}rem`,
	height: `${props.height || props.size || 1.25}rem`,
	fill: 'currentColor',
}));

</script>
